var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner-body"},_vm._l((12),function(n){return _c('div',{key:n,staticClass:"bar",style:(_vm.getStyle(n))})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }